import axios from "axios";

export default function PurchaseorderRequestItemsAddService(items, orderId) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/purchase_order/" + orderId + "/items",
    data: items,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
